module.exports = __webpack_public_path__ + "69681f4c7c8069f85ef1d83e2652e38a.jpg";